import { lazyGetSearchSuggestions } from 'owa-mail-search-store';
import searchStore from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Set the search text for suggestions
 * @param text The text to set
 */
export default action('setSearchTextForSuggestion')(function setSearchTextForSuggestion(text) {
    /**
     * If query text is different from what's already in the store, set it as
     * such and issue request to get new suggestions.
     */
    if (searchStore.searchTextForSuggestion !== text) {
        searchStore.searchTextForSuggestion = text;
        lazyGetSearchSuggestions.importAndExecute();
    }
});
//# sourceMappingURL=setSearchTextForSuggestion.js.map